export const ID_TOKEN = 'idToken'
export const ACCESS_TOKEN = 'accessToken'
export const REFRESH_TOKEN = 'refreshToken'
export const REFRESH_TOKENS_AT = 'refreshTokensAt'
export const REFRESH_TOKEN_REQUEST_LOCKED = 'refreshTokenRequestLocked'
